import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./RootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { reduxBatch } from "@manaflair/redux-batch";
import logger from "redux-logger";

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["auth"], // "auth" persist dışında bırakıldı
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
      thunk: true,
    }).concat(logger),
  devTools: process.env.NODE_ENV !== "production",
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(reduxBatch),
});

export const persistor = persistStore(store);
export default store;
